import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ImageService } from '../../services/image/image.service';
interface GalleryImage {
  src: string;
  category: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit, OnDestroy {

  currentView: 'folders' | 'photos' = 'folders';
  selectedFolderId: string | null = null;
  lightboxOpen = false;
  currentImageIndex = 0;
  private sub: Subscription;
  cmsFolders: any[] = [];
  cmsImages: GalleryImage[] = [];

  folders = [
    {
      id: 'campus',
      name: 'Campus & Infrastructure',
      coverImage: 'assets/img/quick-links/campus/1 (1).jpg',
      description: 'Explore our scenic campus, academic blocks, and institutional facilities.'
    },
    {
      id: 'awards',
      name: 'Academics & Awards',
      coverImage: 'assets/img/quick-links/awards/1 (1).jpg',
      description: 'Celebrating high scholastic excellence, medals, and student achievements.'
    },
    {
      id: 'cultural',
      name: 'Cultural Activities',
      coverImage: 'assets/img/quick-links/cultural/1 (1).jpg',
      description: 'Vibrant stage choreography, traditional folk dances, and music choir fests.'
    },
    {
      id: 'sports',
      name: 'Sports Meet & Athletics',
      coverImage: 'assets/img/quick-links/sports/1 (1).jpg',
      description: 'Annual track runs, relay sprints, yoga demos, and kabaddi challenges.'
    },
    {
      id: 'nss_ncc',
      name: 'NSS & NCC Wing',
      coverImage: 'assets/img/quick-links/nss/1 (1).jpg',
      description: 'Social welfare campaigns, cleanliness drives, and NCC wing drills.'
    },
    {
      id: 'alumni',
      name: 'Alumni Reunion Meet',
      coverImage: 'assets/img/quick-links/alumni-meet/1 (1).jpg',
      description: 'Reuniting former graduating batches to cherish unforgettable memories.'
    },
    {
      id: 'green',
      name: 'Go Green Initiatives',
      coverImage: 'assets/img/quick-links/go-green/3.jpg',
      description: 'Lush green yards, botanical gardens, and environment-friendly drives.'
    }
  ];

  // Curated list using actual photographs in quick-links
  images: GalleryImage[] = [
    // ── CAMPUS & INFRASTRUCTURE ──────────────────────
    {
      src: 'assets/img/quick-links/campus/1 (1).jpg',
      category: 'campus',
      title: 'Lush Green Campus',
      description: 'The scenic and environment-friendly academic campus'
    },
    {
      src: 'assets/img/quick-links/campus/1 (2).jpg',
      category: 'campus',
      title: 'Academic Blocks',
      description: 'State of the art classrooms and institutional blocks'
    },
    {
      src: 'assets/img/quick-links/campus/1 (3).jpg',
      category: 'campus',
      title: 'Modern Library & Labs',
      description: 'Fostering learning through extensive physical resources'
    },
    {
      src: 'assets/img/quick-links/campus/1 (4).jpg',
      category: 'campus',
      title: 'Main Entrance Lobby',
      description: 'Shah Satnam Ji Girls\' College, Sirsa front view'
    },
    {
      src: 'assets/img/quick-links/campus/1 (5).jpg',
      category: 'campus',
      title: 'Beautiful Pathways',
      description: 'Lined pathways designed for clean student walkthroughs'
    },

    // ── ACADEMICS & AWARDS ───────────────────────────
    {
      src: 'assets/img/quick-links/awards/1 (1).jpg',
      category: 'awards',
      title: 'Academic Achievements Ceremony',
      description: 'Felicitation of top-ranking scholars'
    },
    {
      src: 'assets/img/quick-links/awards/1 (2).jpg',
      category: 'awards',
      title: 'Prize Distribution Event',
      description: 'Celebrating high excellence in academics and beyond'
    },
    {
      src: 'assets/img/quick-links/awards/1 (3).jpg',
      category: 'awards',
      title: 'Gold Medalists Honors',
      description: 'Awarding gold medals to outstanding achievers'
    },
    {
      src: 'assets/img/quick-links/awards/1 (4).jpg',
      category: 'awards',
      title: 'College Merit Awards',
      description: 'Inspiring young minds with recognition of excellence'
    },
    {
      src: 'assets/img/quick-links/awards/1 (5).jpg',
      category: 'awards',
      title: 'National Scholarship Ceremony',
      description: 'Encouraging girls from underrepresented backgrounds'
    },
    {
      src: 'assets/img/quick-links/awards/1 (6).jpg',
      category: 'awards',
      title: 'Felicitation Ceremony',
      description: 'Principal and management presenting certificates'
    },

    // ── CULTURAL ACTIVITIES ──────────────────────────
    {
      src: 'assets/img/quick-links/cultural/1 (1).jpg',
      category: 'cultural',
      title: 'Classical Indian Dance',
      description: 'Student performance at the Annual Cultural Celebration'
    },
    {
      src: 'assets/img/quick-links/cultural/1 (2).jpg',
      category: 'cultural',
      title: 'Folk Dance Choreography',
      description: 'Vibrant colors and traditions on stage'
    },
    {
      src: 'assets/img/quick-links/cultural/1 (3).jpg',
      category: 'cultural',
      title: 'Vocal Music Choir',
      description: 'The college band and choir presenting harmonies'
    },
    {
      src: 'assets/img/quick-links/cultural/1 (4).jpg',
      category: 'cultural',
      title: 'Theatrical Plays',
      description: 'Social awareness plays and dramas by the theatre club'
    },
    {
      src: 'assets/img/quick-links/cultural/1 (5).jpg',
      category: 'cultural',
      title: 'Talent Hunt Fest',
      description: 'Welcoming fresher batches with cultural talent showcases'
    },
    {
      src: 'assets/img/quick-links/cultural/1 (6).jpg',
      category: 'cultural',
      title: 'Instrumental Symphony',
      description: 'Showcasing expertise in sitar, tabla, and harmonium'
    },

    // ── SPORTS MEET ──────────────────────────────────
    {
      src: 'assets/img/quick-links/sports/1 (1).jpg',
      category: 'sports',
      title: 'Annual Athletic Meet Rally',
      description: 'Grand march past during the annual sports inaugural'
    },
    {
      src: 'assets/img/quick-links/sports/1 (2).jpg',
      category: 'sports',
      title: 'Kabaddi Tournament',
      description: 'Girls showing exceptional physical grit in Kabaddi matches'
    },
    {
      src: 'assets/img/quick-links/sports/1 (3).jpg',
      category: 'sports',
      title: 'Yoga Demonstration',
      description: 'Mass yoga presentation for health and spiritual awareness'
    },
    {
      src: 'assets/img/quick-links/sports/1 (4).jpg',
      category: 'sports',
      title: 'Tug of War Challenge',
      description: 'High-spirited inter-departmental tug of war finals'
    },
    {
      src: 'assets/img/quick-links/sports/1 (5).jpg',
      category: 'sports',
      title: '100m Relay Sprint',
      description: 'Unleashing speed and teamwork on the tracks'
    },
    {
      src: 'assets/img/quick-links/sports/1 (6).jpg',
      category: 'sports',
      title: 'Shot Put Finals',
      description: 'Cadets showing athletic strength at field events'
    },

    // ── NSS & NCC CAMPS ──────────────────────────────
    {
      src: 'assets/img/quick-links/nss/1 (1).jpg',
      category: 'nss_ncc',
      title: 'NSS Social Awareness Rally',
      description: 'Spreading literacy and health awareness in surrounding villages'
    },
    {
      src: 'assets/img/quick-links/nss/1 (2).jpg',
      category: 'nss_ncc',
      title: 'NSS Cleanliness Campaign',
      description: 'Swachh Bharat Abhiyan activities on and off campus'
    },
    {
      src: 'assets/img/quick-links/nss/1 (3).jpg',
      category: 'nss_ncc',
      title: 'Plantation Drive',
      description: 'NSS volunteers planting trees to celebrate environment day'
    },
    {
      src: 'assets/img/quick-links/ncc/1 (1).jpg',
      category: 'nss_ncc',
      title: 'NCC Drill Training',
      description: 'March past practice and drill routines by NCC cadets'
    },
    {
      src: 'assets/img/quick-links/ncc/1 (2).jpg',
      category: 'nss_ncc',
      title: 'Guard of Honor Ceremony',
      description: 'NCC wing presenting guard of honor to chief guests'
    },
    {
      src: 'assets/img/quick-links/ncc/1 (3).jpg',
      category: 'nss_ncc',
      title: 'NCC Camp Parade',
      description: 'Fostering unit, leadership, and discipline among cadets'
    },

    // ── ALUMNI MEET ──────────────────────────────────
    {
      src: 'assets/img/quick-links/alumni-meet/1 (1).jpg',
      category: 'alumni',
      title: 'Annual Alumni Reunion',
      description: 'Reuniting former batches back to their alma mater'
    },
    {
      src: 'assets/img/quick-links/alumni-meet/1 (2).jpg',
      category: 'alumni',
      title: 'Distinguished Alumni Felicitations',
      description: 'Honoring alumni who achieved massive success in various fields'
    },
    {
      src: 'assets/img/quick-links/alumni-meet/1 (3).jpg',
      category: 'alumni',
      title: 'Alumni Mentorship Sessions',
      description: 'Connecting past students to current students for career guidance'
    },
    {
      src: 'assets/img/quick-links/alumni-meet/1 (4).jpg',
      category: 'alumni',
      title: 'Alumni Reunion Dinner',
      description: 'Cherishing unforgettable college memories and networks'
    },

    // ── GO GREEN ─────────────────────────────────────
    {
      src: 'assets/img/quick-links/go-green/3.jpg',
      category: 'green',
      title: 'Eco-Friendly Campus Yards',
      description: 'Maintaining vast biodiversity and green landscaping'
    },
    {
      src: 'assets/img/quick-links/go-green/go_green_2.jpg',
      category: 'green',
      title: 'Botanical & Herb Gardens',
      description: 'Dedicated conservation park for instructional study and herbs'
    }
  ];

  constructor(private imageService: ImageService) { }

  ngOnInit(): void {
    this.imageService.getImgDetailList();
    this.sub = this.imageService.imgDetailList.snapshotChanges().subscribe(list => {
      const fetchedImages = list.map(item => {
        return {
          $key: item.key,
          ...item.payload.val()
        };
      }).reverse();
      
      this.imageService.setCategory(fetchedImages);
      
      this.cmsFolders = [];
      this.cmsImages = [];
      
      const filterImages = this.imageService.setFilter();
      
      for(let i = 0; i < this.imageService.keys.length; i++) {
        const categoryName = this.imageService.keys[i];
        const categoryImages = this.imageService.getSingleTypeImages(categoryName);
        const coverImg = filterImages[i];
        
        const displayName = categoryName.charAt(0).toUpperCase() + categoryName.slice(1);
        
        let coverImageUrl = '';
        if (coverImg && coverImg.imgUrl) {
          if (Array.isArray(coverImg.imgUrl)) {
            coverImageUrl = coverImg.imgUrl[0];
          } else {
            coverImageUrl = coverImg.imgUrl;
          }
        }
        
        // Add as a folder
        this.cmsFolders.push({
          id: categoryName,
          name: displayName,
          coverImage: coverImageUrl,
          description: ''
        });
        
        // Add images
        categoryImages.forEach((img: any) => {
          if (Array.isArray(img.imgUrl)) {
            img.imgUrl.forEach((url: string) => {
              if (url) {
                this.cmsImages.push({
                  src: url,
                  category: categoryName,
                  title: img.caption,
                  description: ''
                });
              }
            });
          } else if (img.imgUrl) {
            this.cmsImages.push({
              src: img.imgUrl,
              category: categoryName,
              title: img.caption,
              description: ''
            });
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  get allFolders() {
    return [...this.folders, ...this.cmsFolders];
  }

  get allImages() {
    return [...this.images, ...this.cmsImages];
  }

  getFolderImageCount(folderId: string): number {
    return this.allImages.filter(img => img.category === folderId).length;
  }

  get selectedFolderName(): string {
    const folder = this.allFolders.find(f => f.id === this.selectedFolderId);
    return folder ? folder.name : '';
  }

  selectFolder(folderId: string): void {
    this.selectedFolderId = folderId;
    this.currentView = 'photos';
  }

  goBackToFolders(): void {
    this.currentView = 'folders';
    this.selectedFolderId = null;
  }

  // Getter to filter images based on selected folder
  get filteredImages(): GalleryImage[] {
    if (!this.selectedFolderId) {
      return [];
    }
    return this.allImages.filter(img => img.category === this.selectedFolderId);
  }

  // Lightbox controllers
  openLightbox(index: number): void {
    this.currentImageIndex = index;
    this.lightboxOpen = true;
  }

  closeLightbox(): void {
    this.lightboxOpen = false;
  }

  prevImage(event: Event): void {
    event.stopPropagation();
    if (this.currentImageIndex > 0) {
      this.currentImageIndex--;
    } else {
      this.currentImageIndex = this.filteredImages.length - 1;
    }
  }

  nextImage(event: Event): void {
    event.stopPropagation();
    if (this.currentImageIndex < this.filteredImages.length - 1) {
      this.currentImageIndex++;
    } else {
      this.currentImageIndex = 0;
    }
  }
}
